module.exports = __webpack_public_path__ + "img/dept-3.38aefd93.svg";